<div aria-live="polite" class="error-page">
  <span
    aria-hidden="true"
    class="error-page__icon material-symbols-outlined no-fill-icon">
    {{ copy().icon }}
  </span>
  <!-- Inside a page, the page title is the h1. -->
  @if (isRoute()) {
    <h1 class="error-page__title">{{ copy().title | transloco }}</h1>
  } @else {
    <h2 class="error-page__title">{{ copy().title | transloco }}</h2>
  }
  <p class="error-page__description">{{ copy().description | transloco }}</p>

  @switch (kind()) {
    @case ('unavailable') {
      <p-button
        class="error-page__action"
        [label]="'ERRORS.TRY_AGAIN' | transloco"
        (onClick)="onTryAgain()" />
    }
    @case ('not-found') {
      <!-- Inside HCP, its own navigation is the way back. -->
      @if (!isEmbedded) {
        <p-button
          class="error-page__action"
          [label]="'ERRORS.PAGE.GO_TO_DASHBOARD' | transloco"
          (onClick)="goToDashboard()" />
      }
    }
  }
</div>
